<div class="">
  <div class="">
    <div class="flex flex-wrap mb-1">
      <div class="flex-grow-1 pb-1">
        <h2 class="sub-header-bar mb-1">Premiums</h2>
      </div>
      <div class="">
        <button
          type="button"
          pButton
          icon="ui-icon-file-download"
          iconPos="left"
          label="Download"
          (click)="premium_dt.exportCSV()"
          style="float: right"
        ></button>
      </div>
    </div>

    <p-table
      #premium_dt
      exportFilename="Premium Weighing"
      sortField=""
      [value]="page.items"
      [lazy]="true"
      [responsive]="true"
      rowHover="true"
      resizableColumns="true"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="pickupWeight">Pickup Weighting Code</th>
          <th pSortableColumn="dropoffWeight">Dropoff Weighting Code</th>
          <th pSortableColumn="customerPremium">Customer Premium%</th>
          <th pSortableColumn="supplierPremium">Supplier Premium%</th>
          <th>Updated By</th>
          <th pSortableColumn="updatedOn">Updated</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="premium-table">
          <td>{{ item.pickupWeight }}</td>
          <td>{{ item.dropoffWeight }}</td>
          <td pEditableColumn="item">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <strong>{{ item.customerPremium }}</strong>
              </ng-template>
              <ng-template pTemplate="input">
                <input
                  class="cell-input"
                  pInputText
                  [(ngModel)]="item.customerPremium"
                  (change)="cellEdit(item)"
                  [minVal]="0"
                  [maxVal]="999.99"
                  [decimalDigits]="2"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!isPricingAdmin"
                  style="padding: 0 14px"
                />
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn="item">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <strong>{{ item.supplierPremium }}</strong>
              </ng-template>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  [(ngModel)]="item.supplierPremium"
                  (change)="cellEdit(item)"
                  [minVal]="0"
                  class="cell-input"
                  [maxVal]="999.99"
                  [decimalDigits]="2"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!isPricingAdmin"
                  style="padding: 0 14px"
                />
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ item.updatedUserName }}</td>
          <td>
            <div title="{{ item.updatedOn | date : 'dd/MM/yyyy HH:mm' }}">
              {{ item.updatedOn | date : 'dd/MM/yyyy HH:mm' }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---

    <p-dataTabl #premium_dt exportFilename="Premium Weighing" sortField="" [value]="page.items" [lazy]="true" [responsive]="true"
                 rowHover="true" resizableColumns="true"
                 [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" [editable]="tru"
                 [hidden]="!isLoaded">
        <p-column field="pickupWeight" header="Pick-Up Weighting" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="dropoffWeight" header="Drop-Off Weighting" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="customerPremium" header="Customer Premium (%)" [sortable]="tru" [editable]="tru">
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.customerPremium"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999.99" [decimalDigits]="2"
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
            </ng-template>
        </p-column>
        <p-column field="supplierPremium" header="Supplier Premium (%)" [sortable]="tru" [editable]="tru">
            <ng-template let-col let-item="rowData" pTemplate="editor">
                <input pInputText [(ngModel)]="item.supplierPremium"
                       (change)="cellEdit(item)" [minVal]="0" [maxVal]="999.99" [decimalDigits]="2"
                       [ngModelOptions]="{standalone: true}" appendTo="body" />
            </ng-template>
        </p-column>
        <p-column field="updatedByUserName" header="Updated By" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="updatedOn" header="Date/Time" [sortable]="tru" [editable]="false">
            <ng-template pTemplate="body" let-item="rowData">
                <div title="{{item.updatedOn | date:'dd/MM/yyyy HH:mm'}}">
                    {{ item.updatedOn | date:'dd/MM/yyyy HH:mm'}}
                </div>
            </ng-template>
        </p-column>
    </p-dataTable>
    --->
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
